import Swiper from 'swiper'
if (window.innerWidth <= 1024) {
  const containers = document.querySelectorAll('.mosaic-container')
  containers.forEach(container => {
    if (container.classList.contains('in-backend')) {
        return;
    }
    new Swiper(container, {
      slidesPerView: 1.3,
      slideClass: 'mosaic-grid',
      wrapperClass: 'mosaic',
    })
  })
}
